/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_Filter_CategoryInputs */



/**
* | output |
* | --- |
* | "Rating category" |
*
* @param {User_Detail_Filter_CategoryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_filter_category = /** @type {((inputs?: User_Detail_Filter_CategoryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Filter_CategoryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Catégorie de classement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Categoría de clasificación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Categoria de classificação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Categoria di classifica")
	return /** @type {LocalizedString} */ ("Rating category")
});